"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Ryan Lee (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5804%3A1137))
 * @lastsynced 2026-10-29T13:52:28.599Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Market = createSVGIcon(
  <path
    d="M24 11.133h-8.77l7.597-4.385-.867-1.496-7.597 4.385 4.385-7.597-1.501-.867-4.38 7.598V0h-1.734v8.77L6.748 1.174l-1.502.867 4.386 7.597L2.04 5.252l-.867 1.496 7.592 4.385H0v1.734h8.765l-7.592 4.385.867 1.502 7.592-4.386-4.386 7.592 1.502.867 4.385-7.592V24h1.734v-8.765l4.38 7.592 1.5-.867-4.384-7.592 7.597 4.385.867-1.5-7.598-4.386H24z"
    fill="currentColor"
  />,
  "Market",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
